import { toBrowserLocalISODate } from "common/utils/dates";

import { useCurrentDrawer } from "client/common/hooks/stackables";

import {
  DosageReminderCreate,
  DosageReminderItem,
  DosageReminderPatient,
  IsDeliveryMethodSelected,
  ReminderFormValues,
} from "../types";
import { useCreateDosageReminderMutation } from "../hooks";
import ReminderDrawerForm from "./ReminderDrawerForm";

type ReminderCreateFormProps = {
  patient: DosageReminderPatient;
  item: DosageReminderItem;
};

const ReminderCreateForm = ({ patient, item }: ReminderCreateFormProps) => {
  const { close } = useCurrentDrawer();
  const { mutate, isPending, error } = useCreateDosageReminderMutation({
    onSuccess: close,
  });

  const getCreateFields = (
    { nextDoseDate, repeatEvery, intervalUnit, stopDate }: ReminderFormValues,
    isDeliveryMethodSelected: IsDeliveryMethodSelected,
  ): DosageReminderCreate => ({
    patient: patient.id,
    item: item.id,
    frequency: Number(repeatEvery),
    interval_unit: intervalUnit,
    next_dose_date: nextDoseDate && toBrowserLocalISODate(nextDoseDate),
    stop_date: stopDate && toBrowserLocalISODate(stopDate),
    email_enabled: isDeliveryMethodSelected("email"),
    text_enabled: isDeliveryMethodSelected("text"),
  });

  return (
    <ReminderDrawerForm
      patient={patient}
      item={item}
      reminder={null}
      isSubmitting={isPending}
      submitError={error}
      onSubmit={(values, isDeliveryMethodSelected) =>
        mutate(getCreateFields(values, isDeliveryMethodSelected))
      }
      canGoBack={true}
    />
  );
};

export default ReminderCreateForm;
